<template>
  <b-modal
    id="'justificativa'"
    :ref="'justificativa'"
    hide-footer
    hide-header
    centered
    size="md"
    no-close-on-backdrop
  >
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="12">
            <b-button
              variant="none"
              class="close "
              @click="cancelar()"
            >
              <span aria-hidden="true">&times;</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row v-if="!apenasVisualizacao">
          <b-col
            cols="12"
            style="text-align:justify;"
          >
            <h4>
              Informe o motivo de ter marcado o documento como não se aplica!
            </h4>
            <p
              class="text-secondary"
              style="font-size:small"
            >
              Ao realizar essa ação você informará que o documento não deve ser considerado e, caso haja um documento publicado, este será removido
            </p>
          </b-col>
          <div
            class="mt-1 px-1"
            style="flex-grow:1"
          >
            <b-row>
              <b-col cols="12">
                <b-textarea
                  v-model="just"
                  placeholder="Justifique (obrigatório)"
                  rows="3"
                  max-rows="6"
                />
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col cols="6">
                <b-btn
                  variant="danger"
                  class="w-100"
                  @click="cancelar()"
                >Cancelar</b-btn>
              </b-col>
              <b-col cols="6">
                <b-btn
                  variant="success"
                  class="w-100"
                  @click="confirmar()"
                >Confirmar</b-btn>
              </b-col>
            </b-row>
          </div>
        </b-row>
        <b-row v-else>
          <b-col
            cols="12"
            style="text-align:justify;"
          >
            <h4>
              Justificativa de não se aplica
            </h4>
          </b-col>
          <div
            class="my-1 px-1"
            style="flex-grow:1"
          >
            <b-row>
              <b-col cols="12">
                <b-textarea
                  v-model="value"
                  readonly
                  rows="3"
                  max-rows="6"
                />
              </b-col>
            </b-row>
          </div>
        </b-row>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'NaoSeAplica',
  props: {
    value: {
      type: String,
      default: '',
    },
    apenasVisualizacao: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      just: '',
    }
  },
  created() {
    this.$nextTick(() => {
      this.$refs.justificativa.show()
    })
  },
  methods: {
    cancelar() {
      this.$refs.justificativa.hide()
      this.$emit('cancelar')
    },
    confirmar() {
      const justSemEspaco = this.just.replace(/\s+/g, '')
      if (!this.just || justSemEspaco.length < 10) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: !this.just ? 'A justificativa para a marcação de não se aplica é obrigatória.' : 'O motivo deve ter no mínimo 10 caracteres!',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      } else {
        this.$refs.justificativa.hide()
        this.$emit('hidden', this.just)
      }
    },
  },
}
</script>
